import React from "react";
import { ChangeEvent, FormEvent } from "react";
import { Prompt } from "react-router";
import { RouteComponentPropsHistory } from "../../types";
import { Link } from "react-router-dom";

import ValidateInput from "../ValidateInput";

import { V2 } from "../../Api";
// import { formatDateLocalNumeric, formatDateTimeLocalNumeric, formatName, formatTimeLocal } from "../../Utilities";
import withTitle from "../withTitle";

import "../../form.css";
import "../../tasks.css";
import "../viewer.css";

interface ITaskListCreationViewState {
    changedFields: string[];
    hasChanged: boolean;
    isLoading: boolean | string;
    submitStatus: boolean | string;

    attachments: any[];
    body: string;
    subject: string;

    navigationSteps?: number;
    fromIntent: boolean;

    [name: string]: any;
}

class TaskListCreationView extends React.Component<RouteComponentPropsHistory<any, any>, ITaskListCreationViewState> {
    private inputs: ValidateInput[];

    constructor(props: Readonly<RouteComponentPropsHistory<any, any>>) {
        super(props);

        const state: ITaskListCreationViewState = {
            changedFields: [],
            hasChanged: false,
            isLoading: false,
            submitStatus: false,

            attachments: [],
            body: "",
            subject: "",

            fromIntent: false,
        };

        if (props.location.state) {
            state.subject = props.location.state.subject || "";
            state.attachments = props.location.state.attachments || [];
            state.navigationSteps = props.location.state.navigationSteps;
            state.fromIntent = true;
            if (state.navigationSteps && state.navigationSteps < 1) {
                state.navigationSteps = 1;
            }
            state.hasChanged = true;
            state.changedFields.push("subject", "attachments");
        }

        this.state = state;

        this.inputs = [];

        this.receiveValidationRef = this.receiveValidationRef.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.cancelForm = this.cancelForm.bind(this);
        this.formInputChanged = this.formInputChanged.bind(this);
    }

    public async componentDidMount() {
        /*
        try {
            const items = await V2.get<any>("surgery/summary?mode=expanded&status=complete");

            this.setState({
                isLoading: false,
                operations: items
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message
            });
        }
        */
    }

    public render() {
        if (this.state.isLoading === true) {
            return <div className="spinner-center lds-dual-ring-big" />;
        }
        else if (typeof this.state.isLoading === "string") {
            return <span className="error-text">{this.state.isLoading}</span>;
        }

        return (
            <div className="viewer-root with-actionbar">
                <Prompt when={this.state.hasChanged} message="Your changes will not be saved if you continue." />
                <form className="input-form" onSubmit={this.submitForm}>
                    <section className="info-block">
                        <header>
                            <h2>New Task</h2>
                        </header>

                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-subject">Subject</label>
                                <ValidateInput type="text" ref={this.receiveValidationRef} id="frm-subject" name="subject" value={this.state.subject} onChange={this.formInputChanged} autoComplete="off_please_chrome" isRequired={true} autoFocus={!this.state.fromIntent || (this.state.fromIntent && !this.state.subject)} />
                            </div>
                        </section>

                        {
                            this.state.attachments.length > 0
                                ? <section>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-attachments">Attachments</label>
                                        <ul className="tasks-attachment-list">{this.state.attachments.map(a => <li key={a.id}>{this.formatAttachment(a)}</li>)}</ul>
                                    </div>
                                </section>
                                : ""
                        }

                        <section>
                            <div className="input-form-group">
                                <label htmlFor="frm-body">Note</label>
                                <textarea id="frm-body" className="input-textarea-large" name="body" value={this.state.body} onChange={this.formInputChanged} autoComplete="off_please_chrome" autoFocus={this.state.fromIntent && !!this.state.subject} />
                            </div>
                        </section>
                    </section>
                    &nbsp;
                    {
                        this.state.submitStatus === true
                            ? <div className="spinner lds-dual-ring" />
                            : typeof this.state.submitStatus === "string"
                                ? <span className="error-text">{this.state.submitStatus}</span>
                                : ""
                    }
                    <div className="action-panel">
                        <button type="submit" className="button push-right" disabled={this.state.submitStatus === true}>{this.state.isEdit ? "Save" : "Submit"}</button>
                        <button type="button" className="button" onClick={this.cancelForm} disabled={this.state.submitStatus === true}>Cancel</button>
                    </div>
                </form>
            </div>
        );
    }

    private receiveValidationRef(ref: ValidateInput) {
        this.inputs.push(ref);
    }

    private async submitForm(e: FormEvent) {
        e.preventDefault();

        let isAllValid = true;
        for (const input of this.inputs) {
            isAllValid = input.validate() && isAllValid;
        }

        if (!isAllValid) {
            return;
        }

        try {
            this.setState({
                submitStatus: true
            });

            const data = {
                body: this.state.body,
                subject: this.state.subject,

                attachments: this.state.attachments,
            };

            await V2.post("tasks", data);

            this.setState({
                hasChanged: false
            });

            this.cancelForm();
        }
        catch (e) {
            this.setState({
                submitStatus: e.message
            });
        }
    }

    private cancelForm() {
        this.props.history.go(-(this.state.navigationSteps || 1));
    }

    private formInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement> | ChangeEvent<HTMLSelectElement>, callback?: (state: Partial<ITaskListCreationViewState>, prevState: ITaskListCreationViewState) => void) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;

        this.setState(s => {
            if (!s.changedFields.some(a => a === name)) {
                s.changedFields.push(name);
            }

            const newState = {
                changedFields: s.changedFields,
                hasChanged: true,
                [name]: value
            }

            if (callback) {
                const ns: any = {};
                Object.assign(ns, s);
                Object.assign(ns, newState);

                callback(newState, ns);
            }

            return newState;
        });
    }

    private formatAttachment(attach: any) {
        switch (attach.type) {
            case "survey": return <Link to={`/surveys/${attach.surveyId}`}>Questionnaire - {attach.displayText}</Link>;
            case "fair": return <Link to={`/fairs/${attach.fairId}`}>Health Fair - {attach.displayText}</Link>;
            case "appointment": return <Link to={`/appointments/${attach.appointmentId}`}>Appointment - {attach.displayText}</Link>;
            case "surgery": return <Link to={`/surgery/${attach.surgeryId}`}>Surgery - {attach.displayText}</Link>;
            default: return `${attach.type} ${attach.id} ${attach.displayText}`;
        }
    }
}

export default withTitle("New Task", TaskListCreationView);
